import { type GroupData, type IconCardData } from '@af/design-system-docs-ui/cards/types';

export const codeInstallSkill = `npx @atlassian/skills add <skill-name> --universal --yes`;

export const codeInstallPersonalSkill = `npx @atlassian/skills add <skill-name> --global --universal --yes`;

export const codeAgentsInstruction = `When building UI with the Atlassian Design System, use the \`atlassian-design-system\` skill for components, tokens, accessibility, and migrations.

When writing styles, use the \`ui-styling-standard\` skill. Use other installed skills only when they are relevant to the task.`;

export const codeSearchWithCli = `# Atlassians
atlas ads search button

# Public CLI
npx @atlaskit/ads-cli docs button
npx @atlaskit/ads-cli search spacing --type token --json`;

export const codeMcpConfig = `{
  "mcpServers": {
    "ads-mcp": {
      "url": "https://mcp.atlassian.com/v1/ads/public/mcp"
    }
  }
}`;

export const skillCards: GroupData<IconCardData>[] = [
	{
		title: 'Skills',
		cards: [
			{
				title: 'atlassian-design-system',
				description: 'Components, tokens, icons, accessibility, and migrations.',
				href: 'https://go.atlassian.com/agent-skills-atlassian-design-system',
			},
			{
				title: 'atlassian-content-system',
				description: 'UI content standards, voice and tone, and inclusive language.',
				href: 'https://go.atlassian.com/agent-skills-atlassian-content-system',
			},
			{
				title: 'ui-styling-standard',
				description: 'Styling decisions, Compiled CSS-in-JS, and lint rules.',
				href: 'https://go.atlassian.com/agent-skills-ui-styling-standard',
			},
			{
				title: 'frontend-tech-stack',
				description: 'Approved frontend packages and implementation patterns.',
				href: 'https://go.atlassian.com/agent-skills-frontend-tech-stack',
			},
			{
				title: 'add-frontend-offering',
				description: 'Adding reusable frontend offerings to Platform.',
				href: 'https://go.atlassian.com/agent-skills-add-frontend-offering',
			},
			{
				title: 'afm-platform-offerings',
				description: 'Finding reusable Platform components, hooks, and utilities.',
				href: 'https://go.atlassian.com/agent-skills-afm-platform-offerings',
			},
			{
				title: 'a11y-foundation',
				description: 'Accessibility decisions with WCAG and Atlassian guidance.',
				href: 'https://go.atlassian.com/agent-skills-a11y-foundation',
			},
			{
				title: 'design-md',
				description: 'Visual direction for work that should look at home at Atlassian.',
				href: 'https://go.atlassian.com/agent-skills-design-md',
			},
			{
				title: 'motion-animation',
				description: 'Motion tokens, transitions, and reduced motion.',
				href: 'https://go.atlassian.com/agent-skills-motion-animation',
			},
		],
	},
];
